import React, { useContext } from 'react';
import SocialProofingMessage from './components/SocialProofingMessage';
import SwitchTestContext from '../../contexts/SwitchTestContext';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function SocialProofingUKEU() {
  const SwitchTestState = useContext(SwitchTestContext);
  const socialProofingTestState = SwitchTestState['social-proofing'];

  const ProductPageState = useContext(ProductPageContext);
  const { collectionData, activeProduct } = ProductPageState;
  const { hasSocialProofingEnabled, joinedKics } = collectionData;
  const brand = activeProduct?.brand;

  const getSocialProofingTestGroup = () => {
    const socialProofingStateDictionary = {
      b: (
        <SocialProofingMessage
          productIdParam={joinedKics}
          eventType="views"
          timeWindow={60}
          parentBrand={brand}
        />
      ),
      c: (
        <SocialProofingMessage
          productIdParam={joinedKics}
          eventType="atc"
          timeWindow={60}
          parentBrand={brand}
        />
      ),
      d: (
        <SocialProofingMessage
          productIdParam={joinedKics}
          eventType="purchases"
          timeWindow={60}
          parentBrand={brand}
        />
      ),
    };
    const socialProofingContent = socialProofingStateDictionary[socialProofingTestState];

    return socialProofingContent || null;
  };

  return hasSocialProofingEnabled && getSocialProofingTestGroup();
}
